import merge from "./utils/merge"
import DataContainer from "./common/DataContainer"

export default (extendOptions = {}) => {
    return merge.clone({
        defaultLayout: {
            content: {
                appBar: {
                    attrs: {
                        color: "blue darken-3",
                        dark: true
                    },
                    content: {
                        toolbarTitle: {
                            attrs: {
                                style: "width: 300px",
                                class: "ml-0 pl-4"
                            }
                        }
                    }
                }
            }
        },
        btn: {
            target: {
                tooltip: {
                    attrs: {
                        top: true,
                    }
                }
            }
        },
        navMenu: {
            attrs: {
                dense: true,
            },
            content: {
                wrapper: {
                    attrs: {

                    }
                },
                template: {
                    customIcon: {},
                    heading: {
                        attrs: {},
                        content: {
                            btn: {
                                attrs: {},
                                content: {
                                    icon: {
                                        attrs: {}
                                    }
                                }
                            }
                        }
                    },
                    group: {
                        attrs: {},
                        content: {
                            activator: {
                                attrs: {}
                            }
                        }
                    },
                    item: {
                        attrs: {},
                    }
                }
            }
        },
        menu: {
            attrs: {
                bottom: true,
                "offset-y": true,
            },
            content: {
                items: {}
            }
        },
        dialog: {
            attrs: {
                scrollable: true,
                "max-width": "600px",
            },
            content: {
                toolbar: {
                    attrs: {
                        dense: true,
                        flat: true,
                        tile: true,
                        dark: true,
                        color: "primary"
                    }
                },
                content: {
                    makeAttrs(attrs: any = {}, dialog) {
                        attrs.xContext = dialog
                        return attrs
                    }
                },
                cancelDisabled: false,
                buttons: {
                    cancel: {
                        attrs: {},
                        content: {
                            text: "Cancel",
                        },
                        on: {
                            xClick({ self }) {
                                const dialog = self.context()
                                dialog.hide()
                            }
                        }
                    }
                },
                template: {
                    button: {
                        attrs: {
                            color: "blue darken-1",
                            text: true,
                        },
                    },
                }
            }
        },
        confirmDialog: {
            attrs: {
                "max-width": "600px"
            },
            content: {
                title: {
                    attrs: {
                        class: "headline"
                    },
                    html: "Confirm"
                },
                content: {
                    attrs: {}
                },
                buttons: {
                    yes: {
                        attrs: {
                            color: "primary",
                            text: false,
                        },
                        content: {
                            text: "Yes"
                        }
                    },
                    no: {
                        content: {
                            text: "No"
                        },
                        on: {
                            xClick() {
                                console.log("no")
                            }
                        }
                    }
                },
                template: {
                    button: {
                        attrs: {
                            color: "",
                            text: true,
                        }
                    },
                }
            }
        },
        notifyDialog: {
            attrs: {
                "max-width": "600px"
            },
            content: {
                title: {
                    attrs: {
                        class: "headline"
                    },
                    html: "Notify"
                },
                content: {
                    attrs: {}
                },
                buttons: {
                    close: {
                        attrs: {
                            color: "green darken-1",
                            text: true,
                        },
                        content: {
                            text: "OK"
                        }
                    },
                },
            }
        },
        notifySnackBar: {
            attrs: {

            },
            content: {
                content: {
                    html: ""
                },
                button: {},
                template: {
                    button: {
                        attrs: {
                            text: true,
                        },
                        content: {
                            text: "Close"
                        },
                        on: {
                            xClick({ self }) {
                                self.context().model.value = false
                            }
                        }
                    }
                }
            }
        },
        form: {

        },
        input: {
            typeMappings: {
                text: {
                    type: "v-text-field",
                    attrs: {}
                },
                password: {
                    type: "v-text-field",
                    attrs: {
                        type: "password"
                    }
                },
                email: {
                    type: "v-text-field",
                    attrs: {
                        type: "email",
                    },
                    content: {
                        rules: {
                            email: true
                        }
                    }
                },
                phone: {
                    type: "v-text-field",
                    attrs: {
                        type: "tel",
                    },
                    content: {
                        rules: {
                            phoneNumber: true
                        }
                    }
                },
                number: {
                    type: "v-text-field",
                    attrs: {
                        type: "number"
                    }
                },
                integer: {
                    type: "v-text-field",
                    attrs: {
                        type: "number"
                    }
                },
                textLarge: {
                    type: "v-textarea",
                    attrs: {}
                },
                range: {
                    type: "v-slider",
                    attrs: {}
                },
                boolean: {
                    type: "v-switch",
                    attrs: {}
                },
                booleanAlt: {
                    type: "v-checkbox",
                    attrs: {}
                },
                select: {
                    type: "v-select",
                    attrs: {}
                },
                file: {
                    type: "v-file",
                    attrs: {}
                }
            }
        },
        dataTable: {
            attrs: {
                class: "elevation-1",
                "items-per-page": 10,
            },
            content: {
                errorNotifySnackBar: {
                    attrs: {
                        top: true,
                        "multi-line": true,
                        timeout: 0,
                        color: "pink darken-1"
                    },
                    content: {
                        template: {
                            button: {
                                attrs: {
                                    dark: true,
                                    text: true,
                                }
                            }
                        }
                    }
                },
                infoNotifySnackBar: {
                    attrs: {
                        top: true,
                        "multi-line": true,
                        timeout: 5000,
                        color: "cyan darken-2"
                    },
                    content: {
                        template: {
                            button: {
                                attrs: {
                                    dark: true,
                                    text: true,
                                }
                            }
                        }
                    }
                },
                mainToolbar: {
                    attrs: {
                        dense: true,
                        flat: true,
                        color: "grey lighten-3"
                    },
                    content: {
                        multipleSelectActionsButton: {
                            type: "text",
                            attrs: {
                                text: true,
                                color: "",
                                xClass: ""
                            },
                            content: {},
                            target: {
                                menu: {
                                    content: {
                                        items: {}
                                    }
                                }
                            }
                        },
                    }
                },
                filterToolbar: {
                    attrs: {
                        flat: true,
                        dense: true,
                        color: "white"
                    },
                    content: {
                        chipGroup: {
                            attrs: {
                                column: true,
                                "active-class": "primary-text",
                            },
                            content: {
                                template: {
                                    chip: {
                                        attrs: {}
                                    },
                                }
                            }
                        },
                        clearButton: {
                            content: {
                                text: "Clear Filters"
                            },
                            attrs: {
                                text: true,
                                small: true,
                            }
                        },
                        template: {
                            inputDialog: {
                                attrs: {
                                    dense: true,
                                    flat: true,
                                    tile: true,
                                    dark: true,
                                    color: "primary"
                                },
                                content: {
                                    buttons: {
                                        applyButton: {
                                            content: {
                                                text: "Apply"
                                            },
                                            attrs: {
                                                color: "primary",
                                                text: true,
                                            }
                                        }
                                    }
                                }
                            },
                            fieldInput: {
                                attrs: {
                                    "prepend-inner-icon": "add",
                                    dense: true,
                                    flat: true,
                                    "single-line": true,
                                    solo: true,
                                    rounded: true,
                                    placeholder: "Add a filter",
                                }
                            },
                        }
                    },
                },
                template: {
                    topActionButton: {
                        attrs: {
                            color: "primary",
                            text: true,
                            small: true,
                            xClass: "mb-2"
                        }
                    },
                    itemActionButton: {
                        attrs: {
                            text: true,
                            small: true,
                            xClass: "mr-2"
                        }
                    }
                }
            },
        },
        defaultDataTable: {
            content: {
                multipleSelectActions: {
                    template: {
                        action: {
                            targetName: "confirm",
                            confirmMessage(dataTable, action) {
                                return `Are you sure to apply action <b>${action.name}</b> to ${dataTable.model.value.length} item(s)<br/>This cannot be undone!`;
                            },
                            template: {
                                targets: {
                                    confirm: {
                                        content: {
                                            title: {},
                                            content: {
                                                html: dialog => {
                                                    const menu = dialog.context();
                                                    const menuActivator = menu.context();
                                                    const dataTable = menuActivator.context();
                                                    const message = dialog.values.action.confirmMessage(dataTable, dialog.values.action);
                                                    return message;
                                                }
                                            }
                                        },
                                        on: {
                                            async xYes({ self }) {
                                                const dialog = self
                                                const menu = dialog.context();
                                                const menuActivator = menu.context();
                                                const dataTable = menuActivator.context();
                                                const action = dialog.values.action
                                                dataTable.loading.value = true
                                                try {
                                                    await dataTable.options.ext.dataProvider.executeActionOnMultiItems(action.key, dataTable.model.value)
                                                    await dataTable.refresh()
                                                } catch (err) {
                                                    dataTable.error.value = err
                                                } finally {
                                                    dataTable.loading.value = false
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                topActionButtons: {
                    more: {
                        content: {
                            text: "More",
                            icon: "keyboard_arrow_down"
                        },
                        target: {
                            menu: {
                                content: {
                                    items: {},
                                    template: {
                                        selectDisplayColumns: {
                                            content: {
                                                text: "Select display columns",
                                            },
                                            target: {
                                                dialog: {
                                                    content: {
                                                        toolbar: {
                                                            title: "Select columns"
                                                        },
                                                        content: {
                                                            type: "XDataTableColumnSelector",
                                                            makeAttrs(attrs: any = {}, dialog) {
                                                                if (!dialog.values.content) {
                                                                    dialog.values.content = new DataContainer();
                                                                }
                                                                const dialogActivator = dialog.context();
                                                                attrs.xContainer = dialog.values.content;
                                                                return attrs;
                                                            }
                                                        },
                                                        buttons: {
                                                            cancel: {
                                                                on: {
                                                                    xClick({ self }) {
                                                                        const dialog = self.context();
                                                                        dialog.values.content.value.reset();
                                                                        dialog.hide();
                                                                    }
                                                                }
                                                            },
                                                            apply: {
                                                                content: {
                                                                    text: "Apply"
                                                                },
                                                                on: {
                                                                    xClick({ self }) {
                                                                        const dialog = self.context();
                                                                        const menu = dialog.context();
                                                                        const menuActivator = menu.context();
                                                                        const dataTable = menuActivator.context();
                                                                        const displayFields = dialog.values.content.value.getData();
                                                                        dataTable.setDisplayFields(displayFields);
                                                                        dialog.hide();
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                    },
                    insert: {
                        content: {
                            text: "Add new",
                        },
                        target: {
                            dialog: {
                                handlers: {
                                    initialize() {
                                        this.options.content.buttons.save.states.enabled = new DataContainer(false)
                                    }
                                },
                                content: {
                                    toolbar: {
                                        title: "Add new",
                                    },
                                    content: {
                                        type: "XForm",
                                        attrs: {
                                            xOptions: {
                                                on: {
                                                    xSubmit({ self }) {
                                                        self.meta().dialog.getButton("save").emit("xClick")
                                                    }
                                                }
                                            }
                                        },
                                        makeAttrs(attrs: any = {}, dialog) {
                                            if (!dialog.values.formContainer) {
                                                dialog.values.formContainer = new DataContainer()
                                            }
                                            attrs.xData = {}
                                            attrs.xContainer = dialog.values.formContainer
                                            attrs.xModel = dialog.options.content.buttons.save.states.enabled
                                            attrs.xMeta = { dialog }
                                            return attrs
                                        }
                                    },
                                    buttons: {
                                        cancel: {
                                            on: {
                                                xClick({ self }) {
                                                    const dialog = self.context()
                                                    const form = dialog.values.formContainer.value
                                                    form.reset()
                                                    dialog.hide()
                                                }
                                            }
                                        },
                                        save: {
                                            content: {
                                                text: "Save",
                                            },
                                            states: {},
                                            on: {
                                                async xClick({ self }) {
                                                    const dialog = self.context();
                                                    const form = dialog.values.formContainer.value;
                                                    const dialogActivator = dialog.context();
                                                    const dataTable = dialogActivator.context();
                                                    const item = form.getData();
                                                    form.loading.value = true;
                                                    try {
                                                        await dataTable.options.ext.dataProvider.insert(item);
                                                        form.reset();
                                                        dialog.model.value = false;
                                                        await dataTable.refresh();
                                                        dataTable.info.value = dialogActivator.options.ext.message(
                                                            item
                                                        );
                                                    } catch (err) {
                                                        form.error.value = err;
                                                    } finally {
                                                        form.loading.value = false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        ext: {
                            message(item) {
                                return "Item has been added successfully"
                            }
                        }
                    },
                },
                template: {
                    itemActionButtons: {
                        edit: {
                            content: {
                                icon: "edit",
                            },
                            target: {
                                dialog: {
                                    handlers: {
                                        initialize() {
                                            this.options.content.buttons.save.states.enabled = new DataContainer(false)
                                        }
                                    },
                                    content: {
                                        toolbar: {
                                            title: "Edit",
                                        },
                                        content: {
                                            type: "XForm",
                                            attrs: {
                                                xOptions: {
                                                    on: {
                                                        xSubmit({ self }) {
                                                            const dialog = self.meta().dialog
                                                            const saveButton = dialog.getButton("save")
                                                            saveButton.emit("xClick")
                                                        }
                                                    }
                                                }
                                            },
                                            makeAttrs(attrs: any = {}, dialog) {
                                                if (!dialog.values.formContainer) {
                                                    dialog.values.formContainer = new DataContainer()
                                                }
                                                const dialogActivator = dialog.context()
                                                attrs.xData = dialogActivator.context().item
                                                attrs.xContainer = dialog.values.formContainer
                                                attrs.xModel = dialog.options.content.buttons.save.states.enabled
                                                attrs.xMeta = {
                                                    dialog,
                                                }
                                                return attrs
                                            }
                                        },
                                        buttons: {
                                            cancel: {
                                                on: {
                                                    xClick({ self }) {
                                                        const dialog = self.context()
                                                        const form = dialog.values.formContainer.value
                                                        form.reset()
                                                        dialog.hide()
                                                    }
                                                }
                                            },
                                            save: {
                                                content: {
                                                    text: "Save"
                                                },
                                                states: {},
                                                on: {
                                                    async xClick({ self }) {
                                                        self.loading.value = true;
                                                        const dialog = self.context();
                                                        const form = dialog.values.formContainer.value;
                                                        const dialogActivator = dialog.context();
                                                        const dataTable = dialogActivator.context().dataTable;
                                                        const item = form.getData();
                                                        form.loading.value = true;
                                                        try {
                                                            await dataTable.options.ext.dataProvider.update(item);
                                                            form.reset();
                                                            dialog.model.value = false;
                                                            await dataTable.refresh();
                                                            dataTable.info.value = dialogActivator.options.ext.message(
                                                                item
                                                            );
                                                        } catch (err) {
                                                            form.error.value = err;
                                                        } finally {
                                                            form.loading.value = false;
                                                        }
                                                        self.loading.value = false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            ext: {
                                message(item) {
                                    return "Item has been saved successfully"
                                }
                            }
                        },
                        delete: {
                            content: {
                                icon: "delete",
                            },
                            target: {
                                confirm: {
                                    content: {
                                        title: {
                                            html: "Delete item"
                                        },
                                    },
                                    on: {
                                        async xResult({ self, data }) {
                                            if (!data) {
                                                return;
                                            }
                                            const dialogActivator = self.context();
                                            const item = dialogActivator.context().item;
                                            const dataTable = dialogActivator.context().dataTable;
                                            dataTable.loading.value = true;
                                            try {
                                                await dataTable.options.ext.dataProvider.delete(item);
                                                await dataTable.refresh();
                                                dataTable.info.value = dialogActivator.options.ext.message(
                                                    item
                                                );
                                            } catch (err) {
                                                dataTable.error.value = err;
                                            } finally {
                                                dataTable.loading.value = false;
                                            }
                                        }
                                    }
                                }
                            },
                            ext: {
                                message(item) {
                                    return "Item has been deleted successfully"
                                }
                            }
                        }
                    },
                }
            }
        },
    }, extendOptions)
}
